import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, withKeys as _withKeys, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-652052f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"85%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "项目编号：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"70px"}
}, "发布日期：", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 4px"} }, "-", -1))
const _hoisted_10 = { class: "header_nr flexAlign" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "日志内容：", -1))
const _hoisted_12 = { class: "header_nr flexAlign" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "提醒人员：", -1))
const _hoisted_14 = {
  class: "header_nr flexAlign",
  style: {"margin-left":"10px"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("添加日志")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  style: {"white-space":"pre-wrap","word-break":"break-all"}
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  style: {"color":"#c0c4cc"}
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("已处理")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("提醒详情")
const _hoisted_25 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_26 = {
  class: "flexAlign",
  style: {"margin-bottom":"15px"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left",
  style: {"width":"80px","text-align":"right","padding-right":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode("项目编号")
], -1))
const _hoisted_28 = {
  class: "right",
  style: {"flex":"1"}
}
const _hoisted_29 = {
  class: "flexAlign",
  style: {"margin-bottom":"15px"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left",
  style: {"width":"80px","text-align":"right","padding-right":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode("日志内容")
], -1))
const _hoisted_31 = {
  class: "right",
  style: {"flex":"1"}
}
const _hoisted_32 = {
  class: "flexAlign",
  style: {"margin-bottom":"15px"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left",
  style: {"width":"80px","text-align":"right","padding-right":"10px"}
}, "日志附件", -1))
const _hoisted_34 = {
  class: "right",
  style: {"flex":"1"}
}
const _hoisted_35 = { style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap"} }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_37 = { class: "paste_tip" }
const _hoisted_38 = ["href"]
const _hoisted_39 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_40 = {
  class: "flexAlign",
  style: {"margin-bottom":"15px"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left",
  style: {"width":"80px","text-align":"right","padding-right":"10px"}
}, "提醒人员", -1))
const _hoisted_42 = {
  class: "right",
  style: {"flex":"1"}
}
const _hoisted_43 = { style: {"margin-top":"6px"} }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 提醒所有人（仅发送钉钉消息推送，不发送语音提醒） ")
const _hoisted_45 = {
  class: "flexAlign",
  style: {"margin-bottom":"15px"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left",
  style: {"width":"80px","text-align":"right","padding-right":"10px"}
}, "同步任务", -1))
const _hoisted_47 = {
  class: "right",
  style: {"flex":"1"}
}
const _hoisted_48 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_50 = {
  class: "flexAlign",
  style: {"margin-bottom":"15px"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left",
  style: {"width":"80px","text-align":"right","padding-right":"10px"}
}, "回复内容", -1))
const _hoisted_52 = {
  class: "right",
  style: {"flex":"1"}
}
const _hoisted_53 = {
  class: "flexAlign",
  style: {"margin-bottom":"15px"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left",
  style: {"width":"80px","text-align":"right","padding-right":"10px"}
}, "处理附件", -1))
const _hoisted_55 = {
  class: "right",
  style: {"flex":"1"}
}
const _hoisted_56 = { style: {"display":"flex","align-items":"center","gap":"8px","flex-wrap":"wrap"} }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_58 = { class: "paste_tip" }
const _hoisted_59 = ["href"]
const _hoisted_60 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("确定处理")
const _hoisted_63 = {
  key: 0,
  style: {"text-align":"center","padding":"30px","color":"#909399"}
}
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { style: {"margin-bottom":"10px","color":"#606266","font-size":"13px"} }
const _hoisted_66 = { style: {"color":"#67c23a"} }
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 人　｜　未读 ")
const _hoisted_68 = { style: {"color":"#e6a23c"} }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" 人 ")
const _hoisted_70 = { class: "read_grid" }
const _hoisted_71 = { class: "read_name" }
const _hoisted_72 = { class: "read_user" }
const _hoisted_73 = { class: "read_time" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode("关 闭")
const _hoisted_75 = ["href"]

import { onMounted, onBeforeUnmount, computed, ref } from 'vue';
	import { apiName } from '@/api/api';
	import { requestProjectAllList, requestSaveProjectLogInfo, requestGetProjectLogInfoList, requestGetProjectLogReadStatus, requestProcessProjectLog } from '@/api/xmApi';
	import { requestAllUser } from '@/api/api';
	import { Search, Plus } from '@element-plus/icons-vue';
	import { ElMessage, ElMessageBox } from 'element-plus';

	
export default /*#__PURE__*/_defineComponent({
  name: 'ProjectLog',
  setup(__props) {

	const api = ref<string>(apiName)
	const list = ref<any[]>([])
	const loading = ref<boolean>(false)
	const projectlist = ref<any[]>([])
	const userLists = ref<any[]>([])
	const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({ totalCount: 0 })
	const addLogShow = ref<boolean>(false)
	const readStatusShow = ref<boolean>(false)
	const filesShow = ref<boolean>(false)
	const readStatusList = ref<any[]>([])
	const viewFiles = ref<string[]>([])
	const saving = ref<boolean>(false)
	const fileList = ref<any[]>([])
	const processShow = ref<boolean>(false)
	const processing = ref<boolean>(false)
	const processForm = ref({ id: 0, processcontent: "" })
	const processFileList = ref<any[]>([])

	const search = ref({
		projectcode: "",
		startdate1: "",
		startdate2: "",
		content: "",
		reminderuser: ""
	})

	const logForm = ref({
		projectuuid: "",
		projectcode: "",
		content: "",
		reminderusers: [] as string[],
		// 1=提醒所有人：仅钉钉消息推送，不发送语音提醒
		remindall: 0 as any,
		userid: "" as any
	})

	const onProjectChange = (val: string) => {
		const p = projectlist.value.find((item: any) => item.uuid === val)
		if (p) {
			logForm.value.projectcode = p.code
		}
	}

	const showAddLog = () => {
		logForm.value = { projectuuid: "", projectcode: "", content: "", reminderusers: [], remindall: 0, userid: "" }
		fileList.value = []
		addLogShow.value = true
	}

	const handleUploadSuccess = (response: any, file: any, fileListArr: any[]) => {
		// upload success, file already in fileList
	}

	const removeFile = (index: number) => {
		fileList.value.splice(index, 1)
	}
	const removeProcessFile = (index: number) => {
		processFileList.value.splice(index, 1)
	}

	// ===== 日志附件 Ctrl + V 粘贴上传 =====
	// 本页仅在"添加日志"弹窗中有日志附件上传，粘贴即落到该处；弹窗未打开时不拦截，避免影响列表页正常粘贴
	const pasteUploading = ref<boolean>(false)
	const uploadPasteFile = (file: File, target: any) => {
		pasteUploading.value = true
		const fd = new FormData()
		fd.append('file', file, file.name || ('paste_' + Date.now()))
		fetch(`${api.value}/frame/uploadfile1`, { method: 'POST', credentials: 'same-origin', body: fd })
			.then((r: any) => r.json())
			.then((res: any) => {
				if (res && res.errno === 0 && res.data && res.data[0]) {
					const url = res.data[0].url || ''
					const rawName = res.data[0].name || ''
					const name = rawName ? decodeURIComponent(rawName) : (file.name || '附件')
					// 结构与 el-upload 上传成功一致，保证"移除"与取值（response.data[0].url）均可用
					// 用 concat 而非展开语法：项目 tslib 版本较旧，缺少 __spreadArray 帮助器
					target.value = target.value.concat([{ name, url, response: { data: [{ url, name: rawName }] } }])
					ElMessage.success('附件已上传')
				} else {
					ElMessage.error((res && res.msg) || '附件上传失败')
				}
			})
			.catch(() => {
				ElMessage.error('附件上传失败')
			})
			.finally(() => {
				pasteUploading.value = false
			})
	}
	const onPaste = (e: ClipboardEvent) => {
		// 仅在"添加日志"或"标记已处理"弹窗打开时生效
		if (!addLogShow.value && !processShow.value) return
		const items = e.clipboardData && e.clipboardData.items
		if (!items) return
		const files: File[] = []
		for (let i = 0; i < items.length; i++) {
			const it: any = items[i]
			if (it && it.kind === 'file' && it.getAsFile) {
				const f = it.getAsFile()
				if (f) files.push(f)
			}
		}
		if (files.length === 0) return//纯文本粘贴不拦截，不影响文本框正常粘贴
		e.preventDefault()
		// 落到当前打开的弹窗对应的附件列表
		const target = addLogShow.value ? fileList : processFileList
		files.forEach((f: File) => uploadPasteFile(f, target))
	}

	const saveLog = () => {
		if (!logForm.value.projectuuid) {
			ElMessage.warning("请选择项目")
			return
		}
		if (!logForm.value.content) {
			ElMessage.warning("请输入日志内容")
			return
		}
		saving.value = true
		let filelistStr = ""
		if (fileList.value.length > 0) {
			let urls: string[] = []
			for (let i = 0; i < fileList.value.length; i++) {
				const f = fileList.value[i]
				if (f.response && f.response.data && f.response.data[0]) {
					urls.push(f.response.data[0].url)
				}
			}
			filelistStr = urls.join(",")
		}
		requestSaveProjectLogInfo({
			projectuuid: logForm.value.projectuuid,
			projectcode: logForm.value.projectcode,
			content: logForm.value.content,
			filelist: filelistStr,
			reminderusers: logForm.value.reminderusers.join(","),
			// 提醒所有人：仅钉钉推送，不发送语音提醒
			remindall: Number(logForm.value.remindall) === 1 ? 1 : 0,
			userid: logForm.value.userid ? Number(logForm.value.userid) : 0
		}).then((res: any) => {
			saving.value = false
			if (res.status === 1) {
				if (Number(logForm.value.remindall) === 1) {
				ElMessage.success("保存成功，已向所有人发送钉钉消息推送（未发送语音提醒）")
			} else {
				ElMessage.success("保存成功，已发送语音通知与钉钉消息")
			}
				addLogShow.value = false
				getList()
			} else {
				ElMessage.error(res.data || "保存失败")
			}
		})
	}

	const processLog = (row: any) => {
		processForm.value = { id: row.id, processcontent: "" }
		processFileList.value = []
		processShow.value = true
	}
	const submitProcess = () => {
		processing.value = true
		let filelistStr = ""
		if (processFileList.value.length > 0) {
			let urls: string[] = []
			for (let i = 0; i < processFileList.value.length; i++) {
				const f = processFileList.value[i]
				if (f.response && f.response.data && f.response.data[0]) {
					urls.push(f.response.data[0].url)
				}
			}
			filelistStr = urls.join(",")
		}
		requestProcessProjectLog({
			id: processForm.value.id,
			processcontent: processForm.value.processcontent,
			processfilelist: filelistStr
		}).then((res: any) => {
			processing.value = false
			if (res.status === 1) {
				ElMessage.success("已标记为已处理")
				processShow.value = false
				getList()
			} else {
				ElMessage.error(res.msg || res.data || "处理失败")
			}
		}).catch(() => {
			processing.value = false
		})
	}

	// 提醒阅读详情：已读 / 未读人数统计
const readCount = computed(() => readStatusList.value.filter((r: any) => String(r.readstatus) === '1').length)
const unreadCount = computed(() => readStatusList.value.length - readCount.value)
const showReadStatus = (row: any) => {
		requestGetProjectLogReadStatus({ logid: row.id }).then((res: any) => {
			if (res.status === 1) {
				readStatusList.value = res.datalist || []
				readStatusShow.value = true
			}
		})
	}

	const showFiles = (filelist: string) => {
		if (filelist) {
			viewFiles.value = filelist.split(",")
			filesShow.value = true
		}
	}

	const searchList = () => {
		pageIndex.value = 1
		getList()
	}

	const getList = () => {
		loading.value = true
		// 如果选中了具体项目，拆分为编号和名称一起传
		let pcode = ""
		let pname = ""
		if (search.value.projectcode && search.value.projectcode.indexOf("|") > -1) {
			const parts = search.value.projectcode.split("|")
			pcode = parts[0] || ""
			pname = parts[1] || ""
		}
		requestGetProjectLogInfoList({
			pageIndex: pageIndex.value,
			pageSize: pageSize.value,
			projectcode: pcode,
			projectname: pname,
			startdate1: search.value.startdate1,
			startdate2: search.value.startdate2,
			content: search.value.content,
			reminderuser: search.value.reminderuser
		}).then((res: any) => {
			if (res.status === 1) {
				list.value = res.datalist.DataMap || []
				pages.value.totalCount = res.datalist.totalCount || 0
			}
			loading.value = false
		})
	}

	const handleSizeChange = (val: number) => {
		pageSize.value = val
		getList()
	}
	const handleCurrentChange = (val: number) => {
		pageIndex.value = val
		getList()
	}

	const getProjectList = () => {
		requestProjectAllList({}).then((res: any) => {
			projectlist.value = res.datalist || []
		})
	}

	const getUserList = () => {
		requestAllUser({}).then((res: any) => {
			if (res.status === 1) {
				userLists.value = res.datalist || []
			}
		})
	}

	onMounted(() => {
		// 日志附件支持 Ctrl + V 粘贴上传
		document.addEventListener('paste', onPaste)
		getProjectList()
		getUserList()
		getList()
	})

	onBeforeUnmount(() => {
		document.removeEventListener('paste', onPaste)
	})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_select, {
              filterable: "",
              modelValue: search.value.projectcode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.projectcode) = $event)),
              placeholder: "全部",
              style: {"width":"200px"},
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectlist.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: `${item.code} - ${item.projectname}`,
                    value: `${item.code}|${item.projectname}`,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_date_picker, {
              modelValue: search.value.startdate1,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.value.startdate1) = $event)),
              type: "date",
              placeholder: "开始日期",
              "value-format": "YYYY-MM-DD",
              style: {"width":"130px"}
            }, null, 8, ["modelValue"]),
            _hoisted_9,
            _createVNode(_component_el_date_picker, {
              modelValue: search.value.startdate2,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.startdate2) = $event)),
              type: "date",
              placeholder: "结束日期",
              "value-format": "YYYY-MM-DD",
              style: {"width":"130px"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.content,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search.value.content) = $event)),
              style: {width:'120px'},
              onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (searchList()), ["enter"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.reminderuser,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((search.value.reminderuser) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (searchList()), ["enter"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _unref(Search),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (searchList()))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              type: "success",
              size: "small",
              icon: _unref(Plus),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (showAddLog()))
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["icon"])
          ])
        ])
      ])
    ]),
    _hoisted_17,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: list.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "60",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.projectcode",
          label: "项目编号",
          width: "100",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.projectname",
          label: "项目名称",
          width: "120",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.createtime",
          label: "日志发布时间",
          width: "140",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.content",
          label: "日志内容",
          "min-width": "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "是否已处理",
          width: "100",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: scope.row.cell.processstatus==='1'?'success':'warning',
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.cell.processstatus==='1'?'已处理':'未处理'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.reminderusers",
          label: "提醒人员",
          width: "140",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.processuser",
          label: "处理人",
          width: "80",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.processtime",
          label: "处理时间",
          width: "140",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "附件",
          width: "60",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.filelist)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: {"color":"#409EFF","cursor":"pointer"},
                  onClick: ($event: any) => (showFiles(scope.row.cell.filelist))
                }, "查看", 8, _hoisted_18))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "处理回复",
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.processcontent || scope.row.cell.processfilelist)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (scope.row.cell.processcontent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(scope.row.cell.processcontent), 1))
                    : _createCommentVNode("", true),
                  (scope.row.cell.processfilelist)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        style: {"color":"#409EFF","cursor":"pointer"},
                        onClick: ($event: any) => (showFiles(scope.row.cell.processfilelist))
                      }, "查看处理附件", 8, _hoisted_21))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_22, "—"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "160",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            (scope.row.cell.processstatus!=='1')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (processLog(scope.row.cell))
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "warning",
              link: "",
              size: "small",
              onClick: ($event: any) => (showReadStatus(scope.row.cell))
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[10] || (_cache[10] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: addLogShow.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((addLogShow).value = $event)),
      title: "添加项目日志",
      width: "600px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[16] || (_cache[16] = ($event: any) => (addLogShow.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_48
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (saveLog())),
          loading: saving.value
        }, {
          default: _withCtx(() => [
            _hoisted_49
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_el_select, {
              filterable: "",
              modelValue: logForm.value.projectuuid,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((logForm.value.projectuuid) = $event)),
              placeholder: "请选择项目",
              style: {"width":"100%"},
              onChange: onProjectChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectlist.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: `${item.code} - ${item.projectname}`,
                    value: item.uuid,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_el_input, {
              autosize: {minRows: 4},
              type: "textarea",
              modelValue: logForm.value.content,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((logForm.value.content) = $event)),
              placeholder: "请输入日志内容"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_el_upload, {
                action: `${api.value}/frame/uploadfile1`,
                "file-list": fileList.value,
                "on-success": handleUploadSuccess,
                multiple: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_36
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["action", "file-list"]),
              _createElementVNode("span", _hoisted_37, _toDisplayString(pasteUploading.value ? '上传中…' : 'Ctrl+V 粘贴上传附件'), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (f, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                style: {"margin-top":"4px"}
              }, [
                _createElementVNode("a", {
                  href: `${api.value}${f.response?f.response.data[0].url:f.url}`,
                  target: "_blank",
                  style: {"color":"#409EFF","margin-right":"8px"}
                }, _toDisplayString(f.name || '附件'+(i+1)), 9, _hoisted_38),
                _createVNode(_component_el_button, {
                  type: "danger",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (removeFile(i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_el_select, {
              filterable: "",
              multiple: "",
              modelValue: logForm.value.reminderusers,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((logForm.value.reminderusers) = $event)),
              placeholder: "请选择提醒人员(可多选)",
              style: {"width":"100%"},
              disabled: logForm.value.remindall===1
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.name,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"]),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_el_checkbox, {
                modelValue: logForm.value.remindall,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((logForm.value.remindall) = $event)),
                "true-label": 1,
                "false-label": 0
              }, {
                default: _withCtx(() => [
                  _hoisted_44
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_el_select, {
              filterable: "",
              modelValue: logForm.value.userid,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((logForm.value.userid) = $event)),
              placeholder: "不指派则不创建任务",
              style: {"width":"100%"},
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "不指派",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.id,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: processShow.value,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((processShow).value = $event)),
      title: "标记已处理",
      width: "600px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[20] || (_cache[20] = ($event: any) => (processShow.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_61
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (submitProcess())),
          loading: processing.value
        }, {
          default: _withCtx(() => [
            _hoisted_62
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_el_input, {
              autosize: {minRows: 4},
              type: "textarea",
              modelValue: processForm.value.processcontent,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((processForm.value.processcontent) = $event)),
              placeholder: "请输入处理回复内容"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _hoisted_54,
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_el_upload, {
                action: `${api.value}/frame/uploadfile1`,
                "file-list": processFileList.value,
                "on-success": handleUploadSuccess,
                multiple: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_57
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["action", "file-list"]),
              _createElementVNode("span", _hoisted_58, _toDisplayString(pasteUploading.value ? '上传中…' : 'Ctrl+V 粘贴上传附件'), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processFileList.value, (f, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                style: {"margin-top":"4px"}
              }, [
                _createElementVNode("a", {
                  href: `${api.value}${f.response?f.response.data[0].url:f.url}`,
                  target: "_blank",
                  style: {"color":"#409EFF","margin-right":"8px"}
                }, _toDisplayString(f.name || '附件'+(i+1)), 9, _hoisted_59),
                _createVNode(_component_el_button, {
                  type: "danger",
                  link: "",
                  size: "small",
                  onClick: ($event: any) => (removeProcessFile(i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_60
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: readStatusShow.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((readStatusShow).value = $event)),
      title: "提醒阅读详情",
      width: "900px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (readStatusShow.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_74
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (readStatusList.value.length===0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_63, "暂无提醒人员"))
          : (_openBlock(), _createElementBlock("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createTextVNode(" 共 " + _toDisplayString(readStatusList.value.length) + " 人　｜　已读 ", 1),
                _createElementVNode("b", _hoisted_66, _toDisplayString(_unref(readCount)), 1),
                _hoisted_67,
                _createElementVNode("b", _hoisted_68, _toDisplayString(_unref(unreadCount)), 1),
                _hoisted_69
              ]),
              _createElementVNode("div", _hoisted_70, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(readStatusList.value, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["read_item", {'is_read': item.readstatus==='1'}]),
                    key: i
                  }, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("span", _hoisted_72, _toDisplayString(item.reminduser), 1),
                      _createVNode(_component_el_tag, {
                        type: item.readstatus==='1'?'success':'warning',
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.readstatus==='1'?'已读':'未读'), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _createElementVNode("div", _hoisted_73, _toDisplayString(item.readtime || '—'), 1)
                  ], 2))
                }), 128))
              ])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: filesShow.value,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((filesShow).value = $event)),
      title: "日志附件",
      width: "400px"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewFiles.value, (f, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            style: {"margin-bottom":"8px"}
          }, [
            _createElementVNode("a", {
              href: `${api.value}${f}`,
              target: "_blank",
              style: {"color":"#409EFF"}
            }, _toDisplayString(f.split('/').pop()), 9, _hoisted_75)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})